import { type ForwardedRef, type MutableRefObject, useEffect, useRef } from "react";

// Make a difference between undefined (not set) and null (waiting for render)
// Need this difference for useHotKeys
export const useForwardedRef = <T = HTMLElement>(
  ref?: MutableRefObject<T> | ForwardedRef<T>,
): MutableRefObject<T | null> => {
  const innerRef: MutableRefObject<T | null> = useRef<T>(null);

  useEffect(() => {
    if (!ref) return;

    if (typeof ref === "function") {
      ref(innerRef.current);
    } else {
      innerRef.current = ref.current;
    }
  });

  return innerRef;
};
